import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { cpf, cnpj } from "cpf-cnpj-validator";

type AdicionarFornecedorProps = {
  onSave: (fornecedor: { fornecedorDescricao: string; cpfCnpj: string }) => Promise<boolean>;
  onCancel: () => void;
};

const AdicionarFornecedor = ({
  onSave,
  onCancel,
}: AdicionarFornecedorProps) => {
  const [fornecedorDescricao, setFornecedorDescricao] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [loading, setLoading] = useState(false);

  // const isValidCpfCnpj = (value: string): boolean => {
  //   const cleanValue = value.replace(/\D/g, "");

  //   if (cleanValue.length === 11) {
  //     return cpf.isValid(cleanValue);
  //   } else if (cleanValue.length === 14) {
  //     return cnpj.isValid(cleanValue);
  //   }

  //   return false;
  // };
  const handleSubmit = async () => {
    // Fabio Radiguieri informou hoje que não precisa ser obrigatório informar/validar o CPF/CNPJ
    // if (!isValidCpfCnpj(cpfCnpj)) {
    //   toast.error("CPF ou CNPJ inválido");
    //   return;
    // }
    if (fornecedorDescricao.trim().length === 0) {
      toast.error("Preencha o nome antes de enviar");
      return;
    }

    setLoading(true);
    try {
      const success = await onSave({
        fornecedorDescricao: fornecedorDescricao.trim(),
        cpfCnpj: cpfCnpj.trim() || "",
      });

      if (success) {
        toast.success("Fornecedor criado com sucesso!");
        setFornecedorDescricao("");
        setCpfCnpj("");
      } else {
        toast.error("Erro ao criar fornecedor.");
      }
    } catch (error) {
      toast.error("Erro inesperado ao criar fornecedor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Overlay>
      <ModalContainer>
        <Title>Adicionar Fornecedor</Title>
        <InputGroup>
          <Input
            type="text"
            value={fornecedorDescricao}
            placeholder="Nome"
            disabled={loading}
            maxLength={50}
            onChange={(e) => setFornecedorDescricao(e.target.value)}
          />
          <Label>Nome Fornecedor</Label>
        </InputGroup>

        <InputGroup>
          <Input
            type="text"
            value={cpfCnpj}
            placeholder="CNPJ"
            disabled={loading}
            maxLength={14}
            onChange={(e) => setCpfCnpj(e.target.value)}
          />
          <Label>CPF/CNPJ</Label>
        </InputGroup>

        <ButtonGroup>
          <ButtonCancelar onClick={onCancel} disabled={loading}>
            Voltar
          </ButtonCancelar>
          <ButtonEnviar onClick={handleSubmit} disabled={loading}>
            {loading ? "Enviando..." : "Enviar"}
          </ButtonEnviar>
        </ButtonGroup>
      </ModalContainer>
    </Overlay>
  );
};

export default AdicionarFornecedor;

// === styled-components ===

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(20, 25, 41, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContainer = styled.div`
  background: white;
  width: 380px;
  padding: 30px 28px;
  border-radius: 8px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.14);
`;

const Title = styled.h2`
  font-size: 22px;
  color: #2c3e50;
  margin-bottom: 44px;
  text-align: center;
`;

const InputGroup = styled.div`
  position: relative;
  margin-bottom: 30px;
`;

const Input = styled.input`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 12px 12px 12px 12px;
  font-size: 16px;
  border: 1.8px solid #cfd8dc;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #007bff;
  }
`;

const Label = styled.label`
  position: absolute;
  left: 14px;
  top: -10px;
  background: white;
  padding: 0 6px;
  font-size: 13px;
  color: #607d8b;
  pointer-events: none;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ButtonBase = styled.button`
  flex: 1;
  padding: 12px 0;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s;
  border: none;
  margin: 0 8px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const ButtonEnviar = styled(ButtonBase)`
  background-color: rgb(183, 152, 97);
  color: white;

  &:hover:not(:disabled) {
    background-color: rgba(99, 68, 15, 0.747);
  }
`;

const ButtonCancelar = styled(ButtonBase)`
  background-color: #e0e0e0;
  color: #444;

  &:hover:not(:disabled) {
    background-color: #bdbdbd;
  }
`;
